import React, { useState, useEffect, useCallback } from 'react';
import { authService } from '../services/api';
import './Landing.css';

const IMAGES = [
  { src: '/assets/clinic/sala-espera-principal.jpeg', alt: 'Sala de espera principal' },
  { src: '/assets/clinic/quirofano-equipo-anestesia.jpeg', alt: 'Quirofano con equipo de anestesia' },
  { src: '/assets/clinic/ambulancias-exterior-urgencias.jpeg', alt: 'Ambulancias en acceso de urgencias' },
  { src: '/assets/clinic/ambulancia-frontal-urgencias.jpeg', alt: 'Ambulancia de urgencias basicas' },
  { src: '/assets/clinic/camilla-interior-ambulancia.jpeg', alt: 'Camilla e interior de ambulancia' },
  { src: '/assets/clinic/ambulancia-puertas-traseras.jpeg', alt: 'Puertas traseras de ambulancia' },
  { src: '/assets/clinic/ambulancia-rotulada-clinica.jpeg', alt: 'Ambulancia rotulada de Clínica de Especialidades Guarneros' },
  { src: '/assets/clinic/quirofano-sala-operaciones.jpeg', alt: 'Sala de operaciones equipada' },
  { src: '/assets/clinic/quirofano-vista-general.jpeg', alt: 'Vista general de quirofano' },
  { src: '/assets/clinic/pasillo-area-urgencias.jpeg', alt: 'Pasillo del area de urgencias' },
];

const SPECIALTIES = [
  'Pediatria',
  'Cirugia pediatrica',
  'Cirugia general',
  'Cirugia plastica',
  'Neurocirugia',
  'Cardiologia',
  'Traumatologia',
  'Medicina interna',
  'Medicina general',
  'Psicologia',
  'Medicina preventiva',
  'Urgencias',
  'Ultrasonido',
  'Laboratorio',
  'Farmacia',
];

const FALLBACK_DOCTOR_PROFILES = [
  {
    id: 'fallback-general',
    nombre: 'Equipo medico Clínica de Especialidades Guarneros',
    especialidad: 'Medicina general y urgencias',
    resumen_profesional: 'Atencion integral para valoracion inicial, seguimiento y referencia oportuna.',
    certificaciones: ['Medicos cirujanos registrados', 'Formacion universitaria documentada'],
    servicios: ['Consulta medica', 'Valoracion de urgencias', 'Seguimiento de tratamiento'],
    horarios: 'Disponibilidad por agenda de Clínica de Especialidades Guarneros',
    contacto: { telefono: '55 57 75 32 28', whatsapp: '55 57 74 90 88', agenda: '/login' },
    testimonios: []
  }
];

const CONTACT = {
  phones: [
    { label: '55 5775 3228', href: 'tel:+525557753228' },
    { label: '55 5774 9088', href: 'tel:+525557749088' },
  ],
  whatsapp: { label: '55 1829 8914', href: 'https://wa.me/525518298914' },
};

const DIRECTORY = [
  { nombre: 'Dr. Oscar Miranda', especialidad: 'Cirujano Gastrointestinal' },
  { nombre: 'Dr. Oswaldo Yescas Ortiz', especialidad: 'Ginecólogo' },
  { nombre: 'Dra. Carolina Villanueva Parra', especialidad: 'Ginecóloga' },
  { nombre: 'Dr. Eduardo Rodrigo Cortés', especialidad: 'Ginecólogo' },
  { nombre: 'Dr. Carlos Moncayo Piña', especialidad: 'Internista' },
  { nombre: 'Dr. Marco Antonio Pérez de la Sancha', especialidad: 'Otorrinolaringólogo' },
  { nombre: 'Dr. Jorge Ruiz Morales', especialidad: 'Cardiólogo' },
  { nombre: 'Dr. Héctor Omar Jiménez Reyes', especialidad: 'Traumatología y Ortopedia' },
  { nombre: 'Dr. Carlos Sánchez', especialidad: 'Traumatología y Ortopedia' },
];

const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
  </svg>
);

const SERVICES = [
  {
    title: 'Consulta General',
    desc: 'Atención médica integral para toda la familia. Diagnóstico, tratamiento y seguimiento personalizado.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
      </svg>
    ),
  },
  {
    title: 'Laboratorio Clínico',
    desc: 'Análisis clínicos con resultados confiables y rápidos. Biometría, química sanguínea, urianálisis y más.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v11m0 0H5m4 0h4m6-11v11m0 0h-4m4 0h-6"/>
        <path d="M3 9h18M3 15h18"/>
      </svg>
    ),
  },
  {
    title: 'Especialidades',
    desc: 'Contamos con especialistas en diversas áreas para brindarle la atención que su salud merece.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    title: 'Consulta Externa',
    desc: 'Sistema de citas y consulta externa ágil. Reducimos tiempos de espera con tecnología moderna.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
  },
];

const STATS = [
  { number: '+15', label: 'Años de experiencia' },
  { number: '+5K', label: 'Pacientes atendidos' },
  { number: '15', label: 'Especialidades y servicios' },
  { number: '100%', label: 'Compromiso' },
];

const getInitials = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(p => p && !/^dra?\.?$/i.test(p));
  if (parts.length === 0) return 'DR';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
};


const DoctorProfileCard = ({ doctor }) => (
  <article className="landing-doctor-card">
    <div className="landing-doctor-header">
      {doctor.foto_url ? (
        <img className="landing-doctor-photo" src={doctor.foto_url} alt={doctor.nombre} loading="lazy" />
      ) : (
        <div className="landing-doctor-photo landing-doctor-photo--initials">{getInitials(doctor.nombre)}</div>
      )}
      <div>
        <h3>{doctor.nombre}</h3>
        <p>{doctor.especialidad}</p>
      </div>
    </div>
  </article>
);

const HeroSlider = () => {
  const [active, setActive] = useState(0);
  const [prev, setPrev] = useState(null);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback((idx) => {
    if (animating) return;
    setAnimating(true);
    setPrev(active);
    setActive(idx);
    setTimeout(() => { setPrev(null); setAnimating(false); }, 800);
  }, [active, animating]);

  const next = useCallback(() => goTo((active + 1) % IMAGES.length), [active, goTo]);

  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <div className="landing-hero-slider">
      {IMAGES.map((img, i) => (
        <div
          key={img.src}
          className={[
            'landing-slide',
            i === active ? 'landing-slide--active' : '',
            i === prev   ? 'landing-slide--exit'   : '',
          ].filter(Boolean).join(' ')}
        >
          <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} draggable={false} />
          <div className="landing-slide-overlay" />
        </div>
      ))}
      {/* Dots */}
      <div className="landing-dots">
        {IMAGES.map((_, i) => (
          <button
            key={i}
            className={`landing-dot${i === active ? ' landing-dot--active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Imagen ${i + 1}`}
          />
        ))}
      </div>
      {/* Progress bar */}
      <div className="landing-progress">
        <div key={active} className="landing-progress-bar" />
      </div>
    </div>
  );
};

const Landing = ({ onGoToLogin }) => {
  const [doctorProfiles, setDoctorProfiles] = useState(FALLBACK_DOCTOR_PROFILES);

  useEffect(() => {
    let mounted = true;
    const loadPublicDoctors = async () => {
      try {
        const result = await authService.getPublicDoctors();
        if (mounted && result.success && result.data?.length > 0) {
          setDoctorProfiles(result.data);
        }
      } catch {
        if (mounted) setDoctorProfiles(FALLBACK_DOCTOR_PROFILES);
      }
    };
    loadPublicDoctors();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="landing-root">
      {/* ── NAV ── */}
      <nav className="landing-nav">
        <div className="landing-nav-brand">
          <div className="landing-nav-icon">
            <img src="/assets/logos/logo-icon.jpeg" alt="CEG" />
          </div>
          <span>Clínica de Especialidades Guarneros</span>
        </div>
        <button className="landing-nav-btn" onClick={onGoToLogin}>
          Iniciar Sesión
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      </nav>

      {/* ── HERO ── */}
      <section className="landing-hero">
        <HeroSlider />
        <div className="landing-hero-content">
          <p className="landing-hero-eyebrow">Salud, confianza y tecnología</p>
          <h1 className="landing-hero-title">
            Clínica de<br />Especialidades<br />Guarneros
          </h1>
          <p className="landing-hero-sub">
            Atención médica de calidad para toda la familia.<br />
            Consulta externa, laboratorio y especialidades en un solo lugar.
          </p>
          <div className="landing-hero-actions">
            <button
              className="landing-cta-contact"
              onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <PhoneIcon />
              Contáctanos · Agenda tu cita
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <line x1="12" y1="5" x2="12" y2="19"/>
                <polyline points="5 12 12 19 19 12"/>
              </svg>
            </button>
            <button className="landing-cta-primary" onClick={onGoToLogin}>
              Acceder al Sistema
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="landing-stats">
        {STATS.map((s) => (
          <div key={s.label} className="landing-stat">
            <span className="landing-stat-number">{s.number}</span>
            <span className="landing-stat-label">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── SERVICES ── */}
      <section className="landing-services">
        <div className="landing-section-header">
          <p className="landing-section-eyebrow">Lo que ofrecemos</p>
          <h2 className="landing-section-title">Nuestros Servicios</h2>
          <p className="landing-section-sub">
            Brindamos atención médica integral con tecnología moderna y personal altamente capacitado.
          </p>
        </div>
        <div className="landing-services-grid">
          {SERVICES.map((s) => (
            <div key={s.title} className="landing-service-card">
              <div className="landing-service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── GALLERY ── */}
      <section className="landing-specialties-section">
        <div className="landing-section-header">
          <p className="landing-section-eyebrow">Especialidades</p>
          <h2 className="landing-section-title">Atencion medica y servicios integrados</h2>
          <p className="landing-section-sub">
            La receta institucional cita estas areas como parte de la oferta de Clínica de Especialidades Guarneros.
          </p>
        </div>
        <div className="landing-specialties-grid">
          {SPECIALTIES.map((specialty) => (
            <span key={specialty} className="landing-specialty-pill">{specialty}</span>
          ))}
        </div>
      </section>

      <section className="landing-doctors-section">
        <div className="landing-section-header">
          <p className="landing-section-eyebrow">Equipo medico</p>
          <h2 className="landing-section-title">Nosotros</h2>
        </div>
        <div className="landing-doctors-grid">
          {doctorProfiles.map((doctor) => (
            <DoctorProfileCard key={doctor.id} doctor={doctor} />
          ))}
        </div>
      </section>

      <section className="landing-doctors-section landing-directory-section">
        <div className="landing-section-header">
          <p className="landing-section-eyebrow">Directorio</p>
          <h2 className="landing-section-title">Directorio de Especialistas</h2>
        </div>
        <div className="landing-doctors-grid">
          {DIRECTORY.map((doctor) => (
            <DoctorProfileCard key={doctor.nombre} doctor={doctor} />
          ))}
        </div>
      </section>

      <section className="landing-gallery-section">
        <div className="landing-section-header">
          <p className="landing-section-eyebrow">Nuestras instalaciones</p>
          <h2 className="landing-section-title">Conoce la Clínica de Especialidades Guarneros</h2>
        </div>
        <div className="landing-gallery-grid">
          {[
            { src: '/assets/clinic/sala-espera-principal.jpeg', alt: 'Sala de espera principal', wide: true },
            { src: '/assets/clinic/quirofano-sala-operaciones.jpeg', alt: 'Sala de operaciones equipada' },
            { src: '/assets/clinic/ambulancias-exterior-urgencias.jpeg', alt: 'Ambulancias de urgencias' },
            { src: '/assets/clinic/pasillo-area-urgencias.jpeg', alt: 'Area de urgencias' },
            { src: '/assets/clinic/quirofano-vista-general.jpeg', alt: 'Quirofano y equipo medico' },
            { src: '/assets/clinic/camilla-interior-ambulancia.jpeg', alt: 'Interior de ambulancia' },
          ].map((img) => (
            <div key={img.src} className={`landing-gallery-item${img.wide ? ' landing-gallery-item--wide' : ''}`}>
              <img src={img.src} alt={img.alt} loading="lazy" />
              <div className="landing-gallery-overlay"><span>{img.alt}</span></div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CONTACTO ── */}
      <section className="landing-contact-section" id="contacto">
        <div className="landing-section-header">
          <p className="landing-section-eyebrow">Contacto</p>
          <h2 className="landing-section-title">Agenda tu cita</h2>
          <p className="landing-section-sub">Llámanos o escríbenos por WhatsApp.</p>
        </div>
        <div className="landing-contact-actions">
          {CONTACT.phones.map((phone) => (
            <a key={phone.href} className="landing-contact-btn" href={phone.href}>
              <PhoneIcon />
              {phone.label}
            </a>
          ))}
          <a
            className="landing-contact-btn landing-contact-btn--whatsapp"
            href={CONTACT.whatsapp.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon />
            WhatsApp {CONTACT.whatsapp.label}
          </a>
        </div>
      </section>

      {/* ── CTA FOOTER ── */}
      <section className="landing-cta-section">
        <div className="landing-cta-content">
          <h2>¿Eres parte del equipo médico?</h2>
          <p>Accede al sistema de gestión de consulta externa para registrar pacientes, historial clínico y más.</p>
          <button className="landing-cta-primary landing-cta-primary--white" onClick={onGoToLogin}>
            Iniciar Sesión en el Sistema
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="landing-footer">
        <div className="landing-footer-brand">
          <div className="landing-nav-icon">
            <img src="/assets/logos/logo-icon.jpeg" alt="CEG" />
          </div>
          <span>Clínica de Especialidades Guarneros</span>
        </div>
        <div className="landing-footer-contact">
          {CONTACT.phones.map((phone) => (
            <a key={phone.href} href={phone.href}>{phone.label}</a>
          ))}
        </div>
        <p>&copy; {new Date().getFullYear()} Clínica de Especialidades Guarneros &mdash; Todos los derechos reservados</p>
      </footer>

      {/* ── WHATSAPP FLOTANTE ── */}
      <a
        className="landing-whatsapp-float"
        href={CONTACT.whatsapp.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escríbenos por WhatsApp"
      >
        <WhatsAppIcon size={28} />
      </a>
    </div>
  );
};

export default Landing;
